<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="top wrap clear">
            <h2 class="bold mb-10 float-left">내 불참사유서</h2>
            <span class="font-14 float-right cur-pointer mt-10" @click="goReason()">불참사유서 제출 <img src="../assets/img/arrow-right-gray.png"/></span>
        </div>

        <div class="reason-wrap">
            <!-- <div class="clear reason-box">
                    <div class="float-left w-25per txt-left pl-20 reason-box-title" >이름<span class="col-red">*</span></div>
                    <div class="float-left w-75per pr-20">
                        <input type="text" placeholder="이름을 입력해 주세요." class="w-100per"/>
                    </div>
                </div> -->

            <table class="reason-table" cellspacing=0 cellpadding=0 v-if="datalist.length > 0">
                <tr>
                    <th>No</th>
                    <th style="max-width:130px;" class="w-35per">날짜</th>
                    <th>사유</th>
                    <th>상태</th>
                    <th>취소</th>
                </tr>
                <tr v-for="(item,index) in datalist" :key="index">
                    <td>{{ item.no }}</td>
                    <td>{{ item.absence_date }}</td>
                    <td>{{ item.reason_txt }}</td>
                    <td>{{ item.state_txt }}</td>
                    <td>
                        <span class="btn-point cur-pointer" v-if="item.cancel=='W' && item.is_cancel == 'Y'" @click="doCancel(item)">취소하기</span>
                        <span  v-if="item.cancel=='Y' && item.is_cancel == 'N'">-</span>
                        <!-- <button type="button" class="btn-cancel" v-if="irow.cancel=='N'" v-on:click="doCancel(irow)">취소하기</button> -->
                            <!-- <span v-if="irow.cancel=='Y'">-</span> -->
                    </td>
                </tr>
                <!-- <tr>
                    <td>1</td>
                    <td>2020-05-05</td>
                    <td>출장</td>
                    <td>-</td>
                </tr> -->
            </table>
            <table class="reason-table" cellspacing=0 cellpadding=0 v-else>
                <tr>
                    <th>No</th>
                    <th style="max-width:130px;" class="w-35per">날짜</th>
                    <th>사유</th>
                    <th>상태</th>
                    <th>취소</th>
                </tr>
                <tr>
                    <td colspan="5" class="none-list">등록된 불참사유서가 없습니다.</td>
                </tr>
                <!-- <tr>
                    <td>1</td>
                    <td>2020-05-05</td>
                    <td>출장</td>
                    <td>-</td>
                </tr> -->
            </table>
        </div>
        <div class="pl-20 pr-20 pt-20 wrap">
            <button class="btn-base-white float-left" @click="goClass()">My Class</button>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'ResonAdd',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        classid: "",
        datalist:[], total:0
    }),
    mounted() {
        //    this.doc_del_rendar();
        this.classid = this.$route.query.classid;
        this.doSearch();
    },
    methods: {
        created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
        goReason:function(){
            var me = this;
            location.href="/reasonadd?classid="+me.classid;
        },
        goClass:function(){
            var me = this;
            location.href="/class?classid="+me.classid;
        },
        doCancel: function(itm){
            console.log("cancel statement");
            var me = this;
            var params = {
                uidx:localStorage.getItem("uidx")
            }
            if( confirm("취소하시겠습니까?") == true ){
                this.axios.get(this.$store.state.host + '/rest/mobile/classStatementCancel_new/' + me.classid + "/" + itm.regid,{params:params}).then(function (res) {
                    if(res.data.err==0) {
                        alert("취소 되었습니다.");
                        me.doSearch();
                    } else {
                        alert(res.data.err_msg);
                    }
                    me.is_loader = false;
                });
            }
        },
        doSearch: function () {
            console.log("불참사유서 내역 조회");
            var me = this;
            var params = {
                uidx:localStorage.getItem("uidx")
            }
            this.axios.get(this.$store.state.host + '/rest/mobile/classStatementListNew/' + me.classid,{params:params}).then(function (res) {
                if (res.data.err == 0) {
                    me.datalist = res.data.list;
                    me.total = res.data.total;
                    console.log(me.datalist);
                } else {
                    alert(res.data.err_msg);
                }
            });
        },
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    .top {
        padding-right: 20px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        border-bottom: 10px solid #f5f5f5;;
        h2 {
            padding-bottom: 20px;
        }

        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }
        .wrap {
            width: 90%;
            max-width: 700px;
        }
    }

    .reason-wrap {
        width: 90%;
        margin: 0 auto;
        max-width: 700px;
        .reason-table {
            width: 100%;

            tr {
                th {
                    text-align: center;
                    border-bottom: 1px solid #B7B7B7;
                    color: #B7B7B7;
                    ;
                    padding: 12px 0px;
                    font-size: 14px;
                }

                td {
                    font-size: 14px;
                    text-align: center;
                    border-bottom: 1px solid #B7B7B7;
                    padding: 12px 0px;
                }
                td.none-list{
                    text-align: center;
                    padding-top: 30px;
                    padding-bottom: 30px;
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 0px;
                    color: #B7B7B7;
                    opacity: 1;
                }
                &:last-child{
                    th{
                        border-bottom: 0px solid #000;
                    }
                    td{
                        border-bottom: 0px solid #000;
                    }
                }
                
            }
        }
    }

}


.btn-base-white {
    padding: 5px;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;
        .reason-wrap{
            width: 100%;
        }
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }

            &.wrap {
                width: 100%;
                padding-left: 5%;
            }
        }

        .tab {
            &.wrap {
                width: 100%;
            }
        }

        .writing {
            .lecture {
                margin-top: 0px;
                border-top: none;
                border-bottom: 10px solid $border-color;
            }

            table {
                width: 100%;

                th {
                    color: $gray;
                    padding: 8px 10px 0 0;
                    text-align: left;
                    width: 80px;
                }
            }
        }

        // 출결
        .calendar-wrap {
            .calendar-col {
                background: $back-gray;
                padding: 5px 0;
                font-size: 12px;

                &.wrap {
                    width: 100%;
                }

                span {
                    margin-right: 5px;
                }

                .attend {
                    padding-left: 5%;
                }
            }

            .calendar {
                padding: 0px;
            }
        }
    }
    .wrap{
        width: 100%;
    }
}
</style>
